export const getNavProps = (data, selectors) => {
    if(!selectors) {
        return {};
    }

    return data.reduce(
        (acc, item, index) => {
            const isFindItem = selectors.find((item) => item.index === index);
            acc[`Example - ${index + 1}`] = { className: isFindItem ? "warning" : "" };

            return acc;
        },
        {}
    );
};

